import React, { Component } from 'react'
import styled from 'styled-components'
import PropTypes, { number } from 'prop-types'
import { Modal, TextInput, Dropzone, DatePicker, Select, Button, Checkbox } from 'advenio-components'
import { Form } from 'formsy-react'
import moment from 'moment'
import { clone, concat, isEmpty } from 'ramda'
import { pairwise } from 'rxjs/operator/pairwise'

const InputsRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
  padding: 0 8px;
`
const InputContainer = styled.div`
  display: ${({ isOpen }) => (isOpen ? 'flex' : 'none')}
  flex-basis: 30%;
  margin: 0 8px;
`
const DropzoneContainer = styled.div`
  height: 200px;
  width: 100%;
  margin: 16px 0;
`
const ButtonsRow = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin: 16px 0;
`
const DEFAULT_OPTIONS = [{ id: 0, value: '', label: '' }]
const initialCards = [{ header: '', options: DEFAULT_OPTIONS }]

class AddDepositModal extends Component {
  state = {
    file: null,
    showCardSelect: false,
    showPaymentMSI: false,
    cardOptions: initialCards,
    paymentMethods: DEFAULT_OPTIONS,
    parentOptions: [],
    optionsMSI: [
      {id:0, label:"Pago en una exhibición",value:0},
    ],
    total:null,
    amount:null,
    totalBalance:null,
    paid_all:false,
  }

  componentDidMount = () => {
    const parentOptions = this.props.parents.map(parent => ({
      id: parent.userable_id,
      name: `${parent.first_name} ${parent.last_name_paternal}`,
    }))

    this.setState({ parentOptions })
  }

  componentWillUnmount() {
    this.setState({total:0,paid_all:false})
  }

  componentWillReceiveProps = ({ cards, paymentTypes, isOpen }) => {
    if (!isOpen) {
      this.setState({ showCardSelect: false })
    }

    // TODO: Compare props to limit the number of re-renders

    const { parentOptions } = this.state

    if (cards.authorized && cards.authorized.length > 0) {
      const authorizedCards = cards.authorized.filter(card => card !== undefined)

      if (authorizedCards.length > 0 && parentOptions) {
        const cardOptions = parentOptions.reduce((filtered, parent) => {
          const matchingCards = authorizedCards.filter(card => card.parent_id === parent.id)
          const options = matchingCards.map(card => ({
            id: card.id,
            label: `${card.card_brand} ${card.last_four}`,
            value: card.id,
          }))

          if (options.length > 0) {
            filtered.push({
              header: parent.name,
              options,
            })
          }

          return filtered
        }, [])

        let paymentMethods = paymentTypes.map(type => ({
          id: type.id,
          label: type.type.name,
          value: type.id,
        }))

        // Remove card payment method options if neither parent has a credit card
        if (cardOptions.length <= 0) {
          // paymentMethods = paymentMethods.filter(
          //   method => method.label.indexOf('Tarjeta') < 0 && method.label.indexOf('Card') < 0,
          // )
        }

        this.setState({ cardOptions, paymentMethods })
      } else {
        const paymentMethods = paymentTypes.map(type => ({
          id: type.id,
          label: type.type.name,
          value: type.id,
        }))
        // const paymentMethodsWithoutCard = paymentMethods.filter(
        //   method => method.label.indexOf('Tarjeta') < 0 && method.label.indexOf('Card') < 0,
        // )

        this.setState({ paymentMethods })
      }
    } else {
      const paymentMethods = paymentTypes.map(type => ({
        id: type.id,
        label: type.type.name,
        value: type.id,
      }))
      // const paymentMethodsWithoutCard = paymentMethods.filter(
      //   method => method.label.indexOf('Tarjeta') < 0 && method.label.indexOf('Card') < 0,
      // )

      this.setState({ paymentMethods })
    }
  }

  handleSubmit = (data) => {
    const { submitDeposit, studentId } = this.props
    const { file } = this.state

    const date = moment(data.date, 'YYYY-MM-DD')
      .hour(moment().hour())
      .minute(moment().minute())
      .second(moment().second())
      .format('YYYY-MM-DD HH:mm:SS')
    const newForm = new FormData()
    newForm.append('type', 'deposit')
    newForm.append('student_id', studentId)
    newForm.append('date', date)
    newForm.append('method_id', data.method_id)
    newForm.append('total', data.total)
    if(data.payment_type_msi > 0){
      newForm.append('payment_type_msi', data.payment_type_msi)
    }
    if (file) {
      newForm.append('receipt', file)
    }
    if (data.card_id) {
      newForm.append('card_id', data.card_id)
    }

    submitDeposit(studentId, newForm)

    this.setState({ file: null })
  }

  handleFileUpload = file => this.setState({ file })

  handleFormChange = (e) => {
    const { cards, paymentTypes } = this.props
    const paymentType = paymentTypes.find(type => type.id === Number(e.target.value))

    this.setState({
      showCardSelect:
        (paymentType.type.name.indexOf('Tarjeta') >= 0 || paymentType.type.name.indexOf('Card') >= 0) &&
        cards.authorized.length > 0,
      showPaymentMSI:
        (paymentType.type.name.indexOf('Tarjeta') >= 0 || paymentType.type.name.indexOf('Card') >= 0) &&
        cards.authorized.length > 0 && this.state.total > 0,
    })
  }

  handleChange = (model) => {
    const { totalBalance } = this.props
    const  { paid_all } = model
    const total = paid_all ?  Number(totalBalance) : 0

    this.setState({total, paid_all: model.paid_all})
    this.handleTotal({"target":{"value":total}}, model.paid_all)
  }

  handleTotal = ({target:{value}}, paid_all) => {
    const total = Number(value)
    const { paymentTypesMsi } = this.props
    let showPaymentMSI = false
    let optionsMSI = [{id:0, label:"Pago en una sola exhibición",value:0}]
    if(paid_all !== undefined && paid_all){
      showPaymentMSI = true
    }

    if(total >= 300){
      const paymentsMsi =  paymentTypesMsi.filter(p => total >= p.amount_limit) || []
      if(! isEmpty(paymentsMsi)){
        const paymentsTypes =   clone(paymentsMsi.map(paymentMsi => ({
          id: paymentMsi.id
          ,label: paymentMsi.name
          ,value: paymentMsi.id
        })))
        optionsMSI = concat(optionsMSI,paymentsTypes)
      }
    }
    this.setState({showPaymentMSI, optionsMSI})

  }

  render() {
    const { isOpen, onClose, isSending, currency, hasPaymentMSI } = this.props
    const { showCardSelect, cardOptions, paymentMethods, optionsMSI, showPaymentMSI, total, paid_all } = this.state

    if (!isOpen) {
      return null
    }

    return (
      <Modal
        isOpened={isOpen}
        onClose={onClose}
        headerTitle="Agregar Depósito"
        statePath="balance"
        actionType="create"
        typePrefix="BALANCE"
      >
        <Form
          onSubmit={this.handleSubmit}
          onChange={this.handleChange}
          ref={(form) => { this.form = form }}
        >
          <InputsRow>
            <InputContainer isOpen>
              <DatePicker
                name="date"
                label="Fecha"
                value={moment().format('YYYY-MM-DD')}
                disableAfterToday
              />
            </InputContainer>
            <InputContainer isOpen>
              <TextInput
                name="total"
                label="Monto"
                value={total||null}
                prefix={currency && currency.symbol}
                // onChangeCallback={this.handleTotal}
                suffix={currency && currency.code}
                type="number"
                disabled={paid_all}
              />
            </InputContainer>
            <InputContainer isOpen>
              <Select
                name="method_id"
                label="Tipo de Pago"
                onChangeCallback={this.handleFormChange}
                options={paymentMethods}
              />
            </InputContainer>
            {showCardSelect &&
              <InputContainer isOpen>
                <Select
                  name="card_id"
                  label="Tarjetas"
                  withGroup
                  optionsWithGroup={cardOptions}
                  value={cardOptions[0].options[0].value}
                  options={[]}
                />
              </InputContainer>
            }
            {showPaymentMSI && showCardSelect && /*false && */ hasPaymentMSI &&

             <InputContainer isOpen>
               <Select
                 name="payment_type_msi"
                 label="Meses sin interes"
                 value={0}
                 options={optionsMSI}
               />
             </InputContainer>
            }
            { showCardSelect && /*false && */ hasPaymentMSI && Number(this.props.totalBalance) > 300 &&
             <InputContainer isOpen>
               <Checkbox
                 name="paid_all"
                 label="Pagar Todo (Meses sin intereses)"
                 invertedColors
                 large
                 hideEmptyHelpBlock
                 value={false}
                //  disabled={this.state.disabled}
                />
             </InputContainer>
            }
          </InputsRow>
          {!paid_all && (
            <DropzoneContainer>
              <Dropzone
                onDrop={this.handleFileUpload}
                label="Da click o arrastra un documento aquí"
                onDragLabel="Soltar Documento"
                ref={(dropzone) => { this.dropzone = dropzone }}
              />
            </DropzoneContainer>
            )}
          <ButtonsRow>
            <Button onClick={onClose}>Cancelar</Button>
            <Button primary type="submit" loading={isSending}>Agregar</Button>
          </ButtonsRow>
        </Form>
      </Modal>
    )
  }
}

AddDepositModal.propTypes = {
  /** The cards that can be charged */
  cards: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.object,
  ]),
  /** The deposit currency */
  currency: PropTypes.object,
  /** Flag marking whether the modal should be open */
  isOpen: PropTypes.bool,
  /** Flag marking whether an API request is currently being made */
  isSending: PropTypes.bool,
  /** The parents who can be charged */
  parents: PropTypes.array,
  /** The types of payments accepted for the deposit */
  paymentTypes: PropTypes.array.isRequired,
  /** The ID of the student whose account is being deposited to */
  studentId: PropTypes.number.isRequired,

  /** Callback function to be fired when closing the modal */
  onClose: PropTypes.func.isRequired,
  /** Callback function to upload the deposit payment to the API */
  submitDeposit: PropTypes.func.isRequired,
}

AddDepositModal.defaultProps = {
  cards: {},
  currency: {},
  isOpen: false,
  isSending: false,
  parents: [],
}

export default AddDepositModal



// WEBPACK FOOTER //
// ./src/Components/ProfileViews/Balance/AddDepositModal.jsx